import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from 'src/app/helpers/constant';
import { CidaasService } from 'src/app/service/cidaas.service';
import { RegistrationService } from 'src/app/service/registration.service';
import {KEY_DEFAULT_ERROR} from '../../../model/error.model';

@Component({
  selector: 'app-account-deduplication',
  templateUrl: './account-deduplication.component.html',
  styleUrls: ['./account-deduplication.component.scss'],
})
export class AccountDeduplicationComponent implements OnInit {
  requestId!: string;
  trackId!: string;
  provider!: string;
  foundUsers: { email: string; displayName: string; sub: string }[];
  currentEmail!: string;
  selectedAuthMethod: string = '';
  errorMessage: string = '';
  contentLoading: boolean = false;

  constructor(private route: ActivatedRoute, private cidaas: CidaasService, private _router: Router, private registrationSRV: RegistrationService) {
    this.foundUsers = [];
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.requestId = params.requestId || null;
      this.trackId = params.trackId || null;
      this.provider = params.provider || null;
      this.selectedAuthMethod = params.selectedAuthMethod || Constants.AUTH_METHOD_EMAIL;
    });

    if (this.trackId) {
      this.getDeduplicationDetails();
    }
  }

  async getDeduplicationDetails(): Promise<void> {
    this.contentLoading = true;
    const response = await this.cidaas._get().getDeduplicationDetails({
      trackId: this.trackId,
    });
    this.contentLoading = false;
    response.data.deduplicationList.forEach((foundUser) => {
      const { email, displayName, sub } = foundUser;
      this.foundUsers.push({ email, displayName, sub });
    });
    this.currentEmail = response.data.email;
  }

  deduplicationLogin(sub: string): void {
    this.cidaas._get().deduplicationLogin({
      trackId: this.trackId,
      requestId: this.requestId,
      sub: sub,
    });
  }

  async registerDeduplication(): Promise<void> {
    const response = await this.cidaas._get().registerDeduplication({ trackId: this.trackId });
    if (response && response.success && response.data) {
      var resp = response.data;
      if (resp?.action && resp?.redirect_uri) {
        this.registrationSRV._handleRegisterSuccessRedirection(resp);
      } else {
        if (resp.suggested_action === Constants.SUGGESTED_ACTION_LOGIN && resp.trackId) {
          try {
            await this.loginAfterRegister(resp);
          } catch (e) {
            this.errorMessage = KEY_DEFAULT_ERROR;
          }

        } else if (!resp.email_verified) {
          if (this.selectedAuthMethod && this.selectedAuthMethod !== Constants.AUTH_METHOD_PASSWORD) {
            this.callInitiateAccountVerification(resp);
          } else {
            this.navigateToVerificationInit(resp);
          }
        } else {
          this._router.navigate(['/register_success'], { queryParams: { requestId: this.requestId } });
        }
      }
    } else {
      this.errorMessage = KEY_DEFAULT_ERROR;
    }
  }
  callInitiateAccountVerification(data) {
    var initiateVerificationPayload = {
      processingType: Constants.PROCESSING_TYPE_CODE,
      requestId: this.requestId,
      sub: data.sub,
      verificationMedium: this.selectedAuthMethod,
    };

    this.cidaas.initiateAccountVerification(initiateVerificationPayload);
  }

  navigateToVerificationInit(data) {
    this._router.navigate(['/verification_init'], {
      queryParams: {
        requestId: this.requestId,
        userStatus: data.userStatus,
        sub: data.sub,
        provider: Constants.PROVIDER_SELF,
        type: this.selectedAuthMethod,
      },
    });
  }

  async loginAfterRegister(res) {
    let data: any = {};
    data.suggested_action = res.suggested_action;
    data.trackId = res.trackId;
    await this.cidaas._loginAfterRegister(data);
  }
}
